/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Auth_Password_LabelInputs */



/**
* | output |
* | --- |
* | "Password" |
*
* @param {Work_Order_Publish_Auth_Password_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_auth_password_label = /** @type {((inputs?: Work_Order_Publish_Auth_Password_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Auth_Password_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mot de passe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Passwort")
	if (locale === "it") return /** @type {LocalizedString} */ ("Password")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пароль")
	if (locale === "es") return /** @type {LocalizedString} */ ("Contraseña")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("密码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("パスワード")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पासवर्ड")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Senha")
	return /** @type {LocalizedString} */ ("Password")
});